// extracted by mini-css-extract-plugin
module.exports = {"customNav":"navbar-module--customNav--1f1xk","customNavHidden":"navbar-module--customNavHidden--3KZJu","navLink":"navbar-module--navLink--1CyoI"};